import {React, forwardRef} from 'react';
import '../Styles/Checkbox.css';

const Checkbox = forwardRef(function(props, ref) {
	const { id, name, value, title, onChange } = props;
	return (
		<label className='checkbox-container'>
			<input ref={ref} id={id} name={name} value={value} onChange={onChange} type='checkbox'/>
			<span className='checkmark'></span>
			<div className='checkbox-title'>{title}</div>
		</label>
	);
});

export default Checkbox;